import { Box, Button, Divider, styled, Typography } from '@mui/material';
import { Column, Row } from 'further-ui/components/Layout';
import { PropsWithChildren } from 'react';

const Container = styled(Box)({
  width: '100%',
});

type Props = {
  title: string;
  hasDetails: boolean;
  isActive: boolean;
  onEditStart: () => void;
};

const InformationForm: React.FC<PropsWithChildren<Props>> = ({
  children,
  title,
  hasDetails,
  isActive,
  onEditStart,
}) => {
  const handleAddOrEdit = () => {
    onEditStart();
  };

  return (
    <Column fullWidth spacing="sm">
      <Row fullWidth spacing="sm" centered justify="space-between">
        <Typography variant="h6" color="grey.600">
          {title}
        </Typography>
        {!isActive && (
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleAddOrEdit}
          >
            {hasDetails ? 'Edit' : 'Add'}
          </Button>
        )}
      </Row>
      <Divider />
      <Container>{children}</Container>
    </Column>
  );
};

export default InformationForm;
